import type { ITag } from 'services/api/entities';
import { VocalsTag } from 'services/api/entities';
import { SortType, TagStore } from './types';

const withVocals: ITag = new VocalsTag('With vocals', true);
const instrumental: ITag = new VocalsTag('Instrumental', false);

const initialState: TagStore = {
  tags: {
    [withVocals.id]: withVocals,
    [instrumental.id]: instrumental,
  },
  selectedTags: {},
  appliedFilters: {
    sort_by: [SortType.Popular],
  },
  vocals: [withVocals.id, instrumental.id],
};

export default initialState;
